import styles from "./Ribbon.module.css";

export const Ribbon = ({ ribbonText }: { ribbonText: string }) => {
    return (
        <aside
            id="terms-and-conditions-ribbon"
            className={styles.ribbon}
            dangerouslySetInnerHTML={{
                __html: ribbonText,
            }}
        ></aside>
    );
};
